import { lazy, Suspense } from "react";
import LoadingScreen from "../components/loading-screen";
// components

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import("../pages/LoginPage")));

export const Page404 = Loadable(lazy(() => import("../pages/Page404")));

// TODO: my profile

export const MyProfile = Loadable(
  lazy(() => import("../pages/myProfile/MyProfile"))
);

// TODO: general section
export const LandingPage = Loadable(
  lazy(() => import("../pages/general/Dashboard"))
);

export const Notifications = Loadable(
  lazy(() => import("../pages/general/notifications/index"))
);

// export const Profile = Loadable(lazy(() => import("../pages/general/Profile")));

// TODO: users section

export const Admins = Loadable(
  lazy(() => import("../pages/users/admins/Admin"))
);

export const CancelReasons = Loadable(
  lazy(() => import("../pages/supports/CancelReasons"))
);

export const Customers = Loadable(
  lazy(() => import("../pages/users/customers/Customers"))
);

export const DeletedUsers = Loadable(
  lazy(() => import("../pages/users/deletedUsers/DeletedUsers"))
);

export const Otp = Loadable(lazy(() => import("../pages/users/userOTP/Otp")));

// TODO: rides

export const TodayRides = Loadable(
  lazy(() => import("../pages/rides/todayRides/TodayRides"))
);

export const Riders = Loadable(
  lazy(() => import("../pages/users/riders/Riders"))
);

export const Transactions = Loadable(
  lazy(() => import("../pages/accounts/transactions/index"))
);

export const Wallets = Loadable(
  lazy(() => import("../pages/accounts/wallets/index"))
);

// TODO: roles

export const Roles = Loadable(lazy(() => import("../pages/users/roles/Roles")));

// TODO: settings
// TODO: vehicles
export const VehicleBrands = Loadable(
  lazy(() => import("../pages/settings/vehicles/VehicleBrands"))
);

export const VehicleCC = Loadable(
  lazy(() => import("../pages/settings/vehicles/VehicleCC"))
);

export const VehicleColors = Loadable(
  lazy(() => import("../pages/settings/vehicles/VehicleColors"))
);

export const VehicleSymbols = Loadable(
  lazy(() => import("../pages/settings/vehicles/VehicleSymbols"))
);

export const VehicleModels = Loadable(
  lazy(() => import("../pages/settings/vehicles/VehicleModels"))
);

// TODO: promo codes
export const PromoCodes = Loadable(
  lazy(() => import("../pages/settings/promoCodes/PromoCodes"))
);

// TODO: badges
export const Badges = Loadable(
  lazy(() => import("../pages/settings/badges/Badges"))
);

// TODO: commissions
export const Commissions = Loadable(
  lazy(() => import("../pages/settings/commissions/Commissions"))
);

// TODO: rewards
export const Rewards = Loadable(
  lazy(() => import("../pages/settings/rewards/Rewards"))
);

// TODO: basic settings
export const Settings = Loadable(
  lazy(() => import("../pages/settings/Settings"))
);

// TODO: documentType
export const DocumentTypes = Loadable(
  lazy(() => import("../pages/settings/documents/DocumentTypes"))
);

// TODO: categories
export const Categories = Loadable(
  lazy(() => import("../pages/settings/categories/Categories"))
);

// TODO: ratings
export const Ratings = Loadable(lazy(() => import("../pages/ratings/Ratings")));

// TODO: suspendPolicy
export const SuspendPolicies = Loadable(
  lazy(() => import("../pages/settings/suspendPolicies/SuspendPolicies"))
);

// TODO: serviceAreas
export const ServiceAreas = Loadable(
  lazy(() => import("../pages/settings/serviceArea/ServiceAreas"))
);

// TODO: fares
export const Fares = Loadable(
  lazy(() => import("../pages/settings/fares/Fares"))
);

// TODO: farestypes
export const FareTypes = Loadable(
  lazy(() => import("../pages/settings/fares/FareTypes"))
);

// TODO: report types
export const ReportTypes = Loadable(
  lazy(() => import("../pages/supports/reports/ReportTypes"))
);

// TODO: supports
// TODO: emergency contacts
export const EmergencyContacts = Loadable(
  lazy(() => import("../pages/supports/EmergencyContacts"))
);

export const Reports = Loadable(
  lazy(() => import("../pages/supports/reports/Report"))
);

export const Faqs = Loadable(lazy(() => import("../pages/supports/faq/Faqs")));
export const FaqsCategories = Loadable(
  lazy(() => import("../pages/supports/faq/FaqCategories"))
);
